import React from "react";
import { Route, Switch } from "react-router-dom";
import { Area } from "types";
import LessonsList from "./views/LessonsList";
import LessonEditorPage from "./views/LessonEditorPage";

const Lessons: React.VFC = () => (
  <Switch>
    <Route exact path={Area.Lessons_New}>
      <LessonEditorPage />
    </Route>
    <Route path={Area.Lessons_Edit}>
      <LessonEditorPage />
    </Route>
    <Route path={Area.Lessons}>
      <LessonsList />
    </Route>
  </Switch>
);

export default Lessons;
